module.exports = __webpack_public_path__ + "img/discord-logo-light.82e24ea.svg";